import type { ComponentType } from 'react';
import {
    FacebookIcon,
    HudlIcon,
    InstagramIcon,
    LinkedInIcon,
    TikTokIcon,
    XIcon,
} from './MediaKitSocialIcons';
import type { MediaKitSocialFieldKey } from '../utils/mediaKitFormUtils';

export type MediaKitSocialPlatformMeta = {
    label: string;
    placeholder: string;
    iconClass: string;
    Icon: ComponentType<{ className?: string }>;
};

export const MEDIA_KIT_SOCIAL_PLATFORM_META: Record<MediaKitSocialFieldKey, MediaKitSocialPlatformMeta> = {
    instagramHandle: {
        label: 'Instagram',
        placeholder: '@username',
        iconClass: 'media-kit-social-icon-instagram',
        Icon: InstagramIcon,
    },
    linkedinUrl: {
        label: 'LinkedIn',
        placeholder: 'linkedin.com/in/username',
        iconClass: 'media-kit-social-icon-linkedin',
        Icon: LinkedInIcon,
    },
    hudlUrl: {
        label: 'Hudl',
        placeholder: 'hudl.com/profile/123',
        iconClass: 'media-kit-social-icon-hudl',
        Icon: HudlIcon,
    },
    tiktokHandle: {
        label: 'TikTok',
        placeholder: '@username',
        iconClass: 'media-kit-social-icon-tiktok',
        Icon: TikTokIcon,
    },
    facebookName: {
        label: 'Facebook',
        placeholder: 'Your display name',
        iconClass: 'media-kit-social-icon-facebook',
        Icon: FacebookIcon,
    },
    xHandle: {
        label: 'X',
        placeholder: '@username',
        iconClass: 'media-kit-social-icon-x',
        Icon: XIcon,
    },
};
